/**
 * Back to the preferred socket, once it is safe.
 *
 * JsSIP tries sockets by weight and, when one fails, marks it and moves to
 * the next — and then STAYS there until that one fails too. One hiccup on
 * /sip-ws and SIP sat on Asterisk's direct port for the rest of the session,
 * naming CORE while everything else went through the relay (review of
 * SEC-ARCH-007, 03.09.2026). This schedules a return: after a cooldown that
 * doubles on each failed return, and only while no call is up.
 */
export const RETURN_BASE_MS = 60_000;
export const RETURN_MAX_MS = 10 * 60_000;

export function makePreferredReturn({ preferred, isIdle, currentUrl, goBack,
                                      baseMs = RETURN_BASE_MS, maxMs = RETURN_MAX_MS,
                                      timers = { setTimeout: (f, ms) => globalThis.setTimeout(f, ms), clearTimeout: (h) => globalThis.clearTimeout(h) } }) {
  let timer = null, delay = baseMs;
  const clear = () => { if (timer) { timers.clearTimeout(timer); timer = null; } };
  const tick = () => {
    timer = null;
    if (currentUrl() === preferred) { delay = baseMs; return; }      // already home
    if (!isIdle()) { timer = timers.setTimeout(tick, baseMs); return; } // a call is up: not now
    goBack();                                                        // JsSIP reports the outcome via connected()
    delay = Math.min(delay * 2, maxMs);
  };
  return {
    /** Called on every JsSIP 'connected': decides whether a return is due. */
    connected(url) {
      clear();
      if (url === preferred) { delay = baseMs; return false; }
      timer = timers.setTimeout(tick, delay);
      return true;
    },
    stop: clear,
    get pending() { return !!timer; },
  };
}
